module.exports = __webpack_public_path__ + "media/images/front/varieties/HERNANDINA-c5ea1931618de0dee82a63ee595015c5.jpg";